import type { AgentPanelContextType } from './types';
import { useAgentPanelStore } from './use-agent-panel-store';

// Single source of truth mapping a navigation target (the value the LLM
// returned in `request_navigation.target`) to the route the panel should
// navigate to on confirm. Add a new target here AND in the server's
// `NAVIGATION_TARGETS` array (apps/agent-panel/api/src/commands/meta-tools.ts)
// AND in the `navigate` phase enum in shared agent-commands schema. The
// three lists are kept in lockstep so onboarding a new target stays a
// 1-line-per-side change.
export const TARGET_ROUTES: Record<AgentPanelContextType, string> = {
  operations: '/operations',
  products: '/products',
  // Itineraries list page (plural) — natural-language filter requests
  // land here.
  itineraries: '/itineraries',
  // The legacy `itinerary` (singular) handoff also routes to the list
  // page so the consultant can pick which itinerary to drop into. A
  // future iteration may pre-select if the LLM extracted enough
  // context.
  itinerary: '/itineraries',
};

type NavigateStep = {
  target: AgentPanelContextType;
  reason: string;
  replayUtterance: string;
};

// Handle a `phase: 'navigate'` step output. Pure store-mutation: stash the
// proposed handoff so the panel renders the confirm card. Confirmation
// (or cancellation) is driven by `NavigateHandoffCard` — this function
// does NOT navigate. Mirrors how `handlePageActionResult` separates "what
// happened" (store update) from "what UX to render" (the card / toast).
export const handleNavigateHandoff = (step: NavigateStep): void => {
  useAgentPanelStore.getState().setPendingNavigation({
    target: step.target,
    reason: step.reason,
    replayUtterance: step.replayUtterance,
  });
};
